<template lang="pug">
  .card-flips(@click="toggleCard()" v-if="card")
    transition(name="flip")
      .card(v-bind:key="cardFlipped")
        .front(v-if="!cardFlipped")
          .img-wrap(v-if="card.image")
            img(:src="card.image.url" :alt="card.image.alt_text")
          p.xs-f-xsmall.sm-f-small.md-f-medium.max-at-tweak {{card.front}}
        .back.xs-f-xsmall.md-f-small.max-at-tweak(v-else) 
          p.bold.mb-10 {{ card.front }}
          p {{ card.back }}
</template>
<script>
  export default {
    name: "CardFlips",
    props: {
      card: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        cardFlipped: this.card.flipped
      };
    },

    methods: {
      toggleCard() {
        this.trackMREvent('Homepage - Clicked Ingredient Tile');
        this.cardFlipped = !this.cardFlipped;
      },
    }
  };
</script>
<style lang="stylus" scoped>
  .card-flips
    .card
      height 14em
      width 12em
      margin 5%
      display flex
      align-items center
      justify-content center
      background-color #fff
      text-align center
      cursor pointer
      position relative
      will-change transform
      box-shadow 0px 4px 0px rgba(0, 0, 0, 0.08)
      border-radius 5px

      .back
        text-align left
        padding 1em
        overflow auto
        max-height -webkit-fill-available
      
      .front
        display flex
        flex-direction column
        align-self normal
        align-items center
        padding 1em

        .img-wrap
          img
            padding 5%
            margin-bottom 1em
            height 7em
            width 7em

    .flip-enter-active
      transition all 0.4s ease-in-out
    
    .flip-leave-active
      display none
    
    .flip-enter, .flip-leave
      transform rotateY(180deg)
      opacity 0

    @media mq-tablet-less
      .card
        width 9.5em
        height 12em

        .front
          .img-wrap
            img
              height 5em
              width 5em
</style>